import React, { useEffect, useState, useRef } from 'react';

interface BigNumberProps {
  value: number;
  duration?: number;
  className?: string;
  text?: string;
}

const BigNumber: React.FC<BigNumberProps> = ({
  value,
  duration = 1000,
  className,
  text,
}) => {
  const [displayValue, setDisplayValue] = useState(0);
  const elementRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          let start = 0;
          const increment = value / (duration / 16);

          const animate = () => {
            start += increment;
            if (start >= value) {
              setDisplayValue(value);
            } else {
              setDisplayValue(Math.floor(start));
              requestAnimationFrame(animate);
            }
          };

          animate();
        } else {
          setDisplayValue(0);
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [value, duration]);

  return (
    <span
      ref={elementRef}
      className={className}
      style={{
        fontSize: '2rem',
        fontWeight: 'bold',
        color: 'var(--app-accent)',
        display: 'flex',
        flexDirection: 'column-reverse',
        transition: 'all 0.3s ease-in-out',
      }}
    >
      {text && (
        <span
          style={{
            marginRight: '0.5rem',
            fontSize: '1.5rem',
            color: 'var(--app-accent-muted)',
          }}
        >
          {text}
        </span>
      )}
      {displayValue}
    </span>
  );
};

export default BigNumber;
